module.exports = __webpack_public_path__ + "static/img/Orbita-2-Logo.4eebc66.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Orbita-2-Logo.jpg
// module id = 158
// module chunks = 1